import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { DocumentDownloadService } from 'gw-portals-document-js';
import { JsonRPCService } from 'gw-portals-transport-js';

const content = 'Content'; // SAGA added

export default class DocumentService {
    /**
     * Retrieves a document link.
     *
     * @param {String} documentID the documents id to retrieve
     * @param {String} token the security token
     */

    static downloadPolicyDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('policyDocument'), documentID, token);
    }

    // SAGA added
    static getPoliciesDocuments() {
        return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'getPoliciesDocuments', [], []);
    }

    static postDocuments(documentIds) {
        return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'postDocuments', [documentIds], []);
    }

    static postDocumentsWithAlternativeFormat(documentIds, ddaCode) {
        return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'postDocumentsWithAlternativeFormat', [documentIds, ddaCode], []);
    }

    static retrieveCustomerDocumentPdf(reqData, docType) {
        return new Promise((resolve, reject) => {
            return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'getCustomerDocumentPdf_Ext', [reqData, docType]).then((result) => {
                const contentRemove = result.split('Content":"')[1].replace(',"LastModified":null,"FullPath":null}', '').slice(0, -1);
                if (result.length > 0 && result !== 'null') {
                    // remove unrequired data from content pdf string
                    if (result.includes(content)) {
                        result = contentRemove;
                    }
                    const byteCharacters = atob(result);
                    const contentType = 'application/pdf';
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: contentType });

                    resolve(URL.createObjectURL(blob));
                }
                if (result === 'null') {
                    reject();
                }
            }, (err) => {
                reject(err);
            });
        });
    }
}
